import { makeContextModule } from '@cian/react-utils';
import { TAdfoxContextData } from 'shared/types/adfox';

export const { useContext: useAdfoxContext, Context: AdfoxContextData } = makeContextModule<TAdfoxContextData>({
  contextName: 'AdfoxContextData',
});
